<template>
  <b-card header="Tags">
    <b-btn
      variant="success"
      :disabled="tags.length >= maxTags"
      @click="onAddTag">
      <b-icon icon="plus" /> Add Tag
    </b-btn>

    <b-card
      v-for="(tag, i) in tags"
      :key="`${device}-tag-${i}`"
      class="mt-3 mb-2"
      no-body>
      <b-card-header
        header-tag="header"
        header-bg-variant="transparent"
        class="p-2 d-flex drag-title">
        <div
          v-b-toggle="`${device}-tag-${i}`"
          class="pl-1 w-100 d-flex justify-content-between align-items-center"
          @click.prevent="tagOpen = tagOpen === i ? null : i">
          {{ tag.name ? tag.name : "" }}

          <b-icon
            :icon="i === tagOpen ? `chevron-down` : `chevron-right`"
            class="align-self-center ml-auto"
            variant="secondary"
            scale="1.2" />
        </div>
      </b-card-header>

      <b-collapse
        :id="`${device}-${tag.name}-${i}-btn`"
        :visible="tagOpen === i"
        :accordion="`${device}-${tag.name}-btn`"
        role="tabpanel">
        <b-card-body>
          <paywall-form-input
            :device="device"
            label="Name"
            :config="tag"
            config-key="name" />

          <form-color-picker
            v-model="tag.bgColor"
            picker="chrome"
            label="Background Color" />

          <form-color-picker
            v-model="tag.fgColor"
            picker="chrome"
            label="Foreground Color" />

          <b-form-group description="Always enabled for existing tags. Use the 'Delete Tag' button to disable.">
            <b-checkbox
              v-model="tag.enabled"
              :disabled="true"
              switch>
              Enabled
            </b-checkbox>
          </b-form-group>

          <b-button
            variant="danger"
            class="mt-3"
            @click="onDeleteTag(i)">
            Delete Tag
          </b-button>
        </b-card-body>
      </b-collapse>
    </b-card>
  </b-card>
</template>

<script>
import FormColorPicker from "@/components/FormColorPicker"
import PaywallFormInput from "@/components/PaywallV1/PaywallFormInput"

export default {
  name: "PaywallFormPackageTags",
  components: {FormColorPicker, PaywallFormInput},
  props: {
    pkg: {
      type: Object,
      required: true,
    },
    device: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // Currently the clients only support a single tag, but the tags are an array for future proofing in case of more tags.
      maxTags: 1,
      tagOpen: -1,
    }
  },
  computed: {
    tags() {
      return this.pkg.tags && this.pkg.tags.length ? this.pkg.tags : []
    },
  },
  created() {
    // Initialize the enabled flag to true for any existing tags. Disabled tags will be removed from the array.
    for (let i = 0; i < this.pkg.tags.length; i++) {
      this.pkg.tags[i].enabled = true
    }
  },
  methods: {
    onAddTag() {
      this.pkg.tags.push({
        enabled: true,
        name: "Best Value",
        bgColor: "#006EF5",
        fgColor: "#FFFFFF",
      })
    },
    async onDeleteTag(index) {
      this.pkg.tags.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.drag-title {
  border: 1px solid transparent;
}

.drag-title:hover > div > .bi-chevron-right {
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon;
}

.drag-title:hover {
  border: 1px solid var(--primary);
  transition: all 50ms ease;
  cursor: grab;
}

.drag-title:active, .drag-title:focus {
  cursor: grabbing;
  color: white;
  background: darkgrey;
  transform: scale(1.06);
  transition: transform 50ms ease;
}
</style>
